import $ from 'jquery';
// import whatInput from 'what-input';

window.$ = $;

import './lib/foundation-explicit-pieces';
$(document).foundation();

// own code

import * as func from './lib/functions';
import './lib/jumplink';
import './lib/backtotop';
import Confirm from './lib/confirm';
// import FloatLabel from './lib/floatlabel';
import SubmitForm from './lib/submitForm';
// import RestrictPageInputs from './lib/restrictPageInputs';
import Textarea from './lib/textarea';
import './lib/lightBox';

(function(window, document) {
    Confirm.setup();
    // FloatLabel.setup();
    SubmitForm.setup();
    // RestrictPageInputs.setup();
    Textarea.setup();
})(window, window.document);